import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Pagination from "./Pagination/container";
import Result from "./Result/container";
import SearchInput from "./SearchInput/container";
import "./style.less";

export type MapProps = RootContainerProps & {};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <Container className="wsc_content_cartly_search" {...getContainerProps(props)}>
    <SearchInput {...getRootContainerProps(props)} />

    <Result {...getRootContainerProps(props)} />

    <Pagination {...getRootContainerProps(props)} />
  </Container>
);
